// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { LMLoggerService, LMUrlUtilService } from '@services/index';
import { FormResource } from '@resources/form.resource';
import { LMNavigationService } from '@navigation/lm-navigation.service';
import { LMConditionUtilService } from '@utils/lm-condition-util.service';
import * as urltemplate from 'url-template';

@Injectable()
export class LMFormMatrixService {
  constructor(
    private lmLoggerService: LMLoggerService,
    private lmUrlUtilService: LMUrlUtilService,
    private lmNavigationService: LMNavigationService,
    private lmConditionUtilService: LMConditionUtilService
  ) {}

  public runMatrixLinkNavigation(formUrlInfo: LMFormUrlInfo, formSpec: LMFormSpec, dataView: LMDataView, displayField: LMListDisplayField) {
    this.lmLoggerService.log('runMatrixLinkNavigation');

    if (displayField.linkNavigation || displayField.navigation) {
      const linkNavigation = displayField.linkNavigation || displayField.navigation;
      this.lmLoggerService.log('runMatrixLinkNavigation: ' + linkNavigation);
      const compiledUrlTemplate = urltemplate.parse(formUrlInfo.navigationUrl);
      const url = compiledUrlTemplate.expand({ resourceId: dataView.resourceId, navigationName: linkNavigation });

      this.lmNavigationService.runNavigation(url, undefined, {showAsPdf: displayField.showAsPdf});
    }
  }

  public copyStateValuesToCellView(rowDataViewsSet: LMDataViewSet) {
    const rowHeader: LMDataView = rowDataViewsSet.header;
    const rowDataViewList: Array<LMDataView> = rowDataViewsSet.data;

    for (let i = 0, l = rowDataViewList.length; i < l; i++) {
      const rowDataView = rowDataViewList[ i ];
      const cellDataViewList = rowDataView.data;

      for (let j = 0, jl = cellDataViewList.length; j < jl; j++) {
        const cellDataView: LMDataView = cellDataViewList[ j ];

        for (const fieldId in cellDataView.fields) {
          if (rowHeader.fields[ fieldId ] && rowHeader.fields[ fieldId ].stateValues !== undefined) {
            cellDataView.fields[ fieldId ].stateValues = rowHeader.fields[ fieldId ].stateValues;
          }
        }
      }
    }
  }

  public getValidCheckControlActions(
    displayField: LMListDisplayField,
    dataView: LMDataView,
    isChecked?: boolean
  ): Array<LMActionSpec> {
    const checkControlActions: Array<LMCheckControlAction> = isChecked ? displayField.checkActions : displayField.uncheckActions;

    if (checkControlActions === null || checkControlActions.length === 0) {
      this.lmLoggerService.warn([ this, 'runCheckControlAction: No ' + (isChecked ? 'Check' : 'Uncheck') + ' actions defined.' ]);
      return;
    }

    const validActions: Array<LMActionSpec> = [];

    checkControlActions.forEach((checkControlAction: LMCheckControlAction) => {
      if (checkControlAction.condition) {
        const conditions: LMCondition[] = [];
        conditions[ 0 ] = checkControlAction.condition;

        if (this.lmConditionUtilService.isValid(conditions, dataView)) {
          validActions.push(checkControlAction.actionSpec);
        }
      } else {
        validActions.push(checkControlAction.actionSpec);
      }
    });

    if (validActions.length === 0) {
      this.lmLoggerService.warn([ this, 'runCheckControlAction: No valid ' + (isChecked ? 'Check' : 'Uncheck') + ' action defined.' ]);
      return;
    }

    return validActions;
  }
}
